export default ({ request }) => ({
  shipmentCustomerSettingUserRangeGetUserCodeListApi(data = {}) {
    return request({
      url: '/factory/shipment/customerSetting/userRange/getUserCodeList',
      method: 'post',
      data
    })
  },
  shipmentCustomerSettingUserRangeSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/customerSetting/userRange/save',
      method: 'post',
      data
    })
  },
  // 发运客户配置
  shipmentCustomerSettingListApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSetting/list',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingDetailApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSetting/detail',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSetting/save',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingDelApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSetting/del',
      method: 'post',
      data,
    })
  },
  // 发运客户报关金额配置
  shipmentCustomerSettingDeclarationListApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingDeclaration/list',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingDeclarationDetailApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingDeclaration/detail',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingDeclarationSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingDeclaration/save',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingDeclarationDelApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingDeclaration/del',
      method: 'post',
      data,
    })
  },
  // 发运客户清关HSCODE配置
  shipmentCustomerSettingHscodeListApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingHscode/list',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingHscodeDetailApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingHscode/detail',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingHscodeSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingHscode/save',
      method: 'post',
      data,
    })
  },
  shipmentCustomerSettingHscodeDelApi(data = {}) {
    return request({
      url: '/factory/shipmentCustomerSettingHscode/del',
      method: 'post',
      data,
    })
  },

    // 发运客户预警规则配置
    shipmentCustomerSettingAlertListApi(data = {}) {
      return request({
        url: '/factory/shipment/customer/setting/alert/list',
        method: 'post',
        data,
      })
    },
    shipmentCustomerSettingAlertDetailApi(data = {}) {
      return request({
        url: '/factory/shipment/customer/setting/alert/detail',
        method: 'post',
        data,
      })
    },
    shipmentCustomerSettingAlertSaveApi(data = {}) {
      return request({
        url: '/factory/shipment/customer/setting/alert/save',
        method: 'post',
        data,
      })
    },
    shipmentCustomerSettingAlertDelApi(data = {}) {
      return request({
        url: '/factory/shipment/customer/setting/alert/del',
        method: 'post',
        data,
      })
    },
})
